import { render, staticRenderFns } from "./ModalRankTest.vue?vue&type=template&id=24e1f066&scoped=true"
import script from "./ModalRankTest.vue?vue&type=script&lang=js"
export * from "./ModalRankTest.vue?vue&type=script&lang=js"
import style0 from "./ModalRankTest.vue?vue&type=style&index=0&id=24e1f066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e1f066",
  null
  
)

export default component.exports